<script lang="ts">
  import { getTimeZone } from "../data/clock";
  import { ensureDate } from "../support/dates";
  import { getLocale } from "../domain/locale";
  import Locale from "./locale.svelte";

  export let date: Date;
  export let timeZone = getTimeZone();
  export let label = "weekday.label";

  $: formatter = new Intl.DateTimeFormat(getLocale(), {
    weekday: "long",
    timeZone: $timeZone
  });

  function localTime(date: Date) {
    return formatter.format(ensureDate(date));
  }
</script>

<time datetime={date.toISOString()}>
  <Locale {label} vars={{ day: localTime(date) }} />
</time>
